<template>
  <div class="table-pareri shadow-lg bg-white card p-3">

    <TableView :columns="columns" :items="questions" :pagination="pagination" :sort-field="sortField"
      :sort-direction="sortDirection" @page-change="$emit('page-change', $event)" @sort="$emit('sort', $event)">

      <!-- ID -->
      <template #id="{ item }">
        <span class="clickable-id" @click="$emit('change-view', 'QuestionDetailView', item.id)">
          {{ item.id }}
        </span>
      </template>

      <!-- OGGETTO -->
      <template #object="{ item }">
        <div class="td-object">
          {{ item.object }}
        </div>
      </template>

      <template #empty>
        Nessun parere trovato.
      </template>

    </TableView>

  </div>
</template>

<script>
import TableView from '../../../../components/common/TableView.vue';

export default {
  name: 'PareriTable',
  components: { TableView },

  props: [
    'questions',
    'pagination',
    'sortField',
    'sortDirection'
  ],

  data() {
    return {
      columns: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
          headerClass: 'bg-primary text-white'
        },
        {
          key: 'object',
          label: 'Oggetto del Quesito',
          sortable: false,
          headerClass: 'bg-primary text-white'
        }
      ]
    };
  }
};
</script>

<style scoped>
.table-pareri table {
  table-layout: fixed;
  width: 100%;
  font-size: 0.8rem;
  line-height: 1.35;
}

.table-pareri ::v-deep(.modern-table th:nth-child(1)),
.table-pareri ::v-deep(.modern-table td:nth-child(1)) {
  width: 90px !important;
  min-width: 90px !important;
  max-width: 90px !important;
  text-align: center;
  white-space: nowrap;
}

.table-pareri table th:nth-child(2),
.table-pareri table td:nth-child(2) {
  width: 80%;
  text-align: left;
}

.table-pareri ::v-deep(th:nth-child(1) .sort-icon) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.table-pareri ::v-deep(thead th) {
  background-color: #0066cc !important;
  color: #fff !important;
  text-align: center;
}

.td-object {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}

.table-pareri table thead th,
.table-pareri table tbody td {
  padding: 0.5rem 0.6rem !important;
}

.table-pareri ::v-deep(th.sorted .sort-icon),
.table-pareri ::v-deep(th.sortable .sort-icon) {
  color: #fff !important;
  text-align: left !important;
}

.detail-section {
  background: #fff;
  border-radius: 0.6rem;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.detail-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  border-bottom: 2px solid #0d6efd;
  padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
}

.form-control-plaintext {
  background-color: #f1f3f5;
  padding: 0.6rem 0.8rem;
  border-radius: 0.5rem;
  word-break: break-word;
}

.table-pareri ::v-deep(.modern-table tbody tr:nth-of-type(odd)) {
  background-color: #f6f9ff; /* azzurrino */
}

.table-pareri ::v-deep(.modern-table tbody tr:nth-of-type(even)) {
  background-color: #ffffff;
}

.clickable-id {
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  background: rgba(0, 102, 204, 0.10);
  color: #0066cc;
  font-weight: 700;
}

.clickable-id:hover {
  background: rgba(0, 102, 204, 0.18);
}

.table-pareri ::v-deep(.modern-table tbody tr) {
  transition: background-color 0.18s ease;
}

.table-pareri ::v-deep(.modern-table tbody tr:hover) {
  background-color: rgba(0, 102, 204, 0.08);
}

.table-pareri ::v-deep(.modern-table tbody td) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-pareri ::v-deep(.modern-table tbody tr:last-child td) {
  border-bottom: none;
}

.clickable-id:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.25);
}

.table-pareri ::v-deep(.modern-table thead th) {
  background: linear-gradient(180deg, #0b5ed7 0%, #0066cc 100%) !important;
  color: #fff !important;
  text-align: center;
  padding: 0.75rem 0.8rem;
  border-bottom: 2px solid rgba(255,255,255,0.35);
}
</style>